import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 p-6 text-center bg-galaxia">
      <AlertCircle size={48} className="text-destructive" />
      <h2 className="text-foreground text-xl font-semibold">Erro ao carregar dados</h2>
      <p className="text-muted-foreground">{error.message}</p>
      <button
        onClick={onRetry}
        className="mt-4 px-5 py-2.5 bg-primary text-primary-foreground rounded-lg text-sm font-semibold hover:bg-primary/90 transition-colors"
      >
        Tentar Novamente
      </button>
    </div>
  );
};
